import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { FLayout, FMain, FContainer } from "ferrum-design-system";
import DashboardHeader from "./DashboardHeader";
import VestingDashboardHeader from "./VestingDashboardHeader";
import DashboardSidebar from "./DashboardSidebar";
import DashboardFooter from "./DashboardFooter";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import WindowLockWarningIcon from "../../assets/img/window-lock-warningicon.png";
import * as NetworkActions from "../../redux/slices/network";
import { useWalletConnector } from "foundry";

const DashboardLayout = ({ headerTitle, children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.config);
  const { networksPayload } = useSelector((state) => state.networks);
  const { isSwappingScreenBlocked } = useSelector((state) => state.swap);
  const { currentNetworkChainId, isConnected } = useWalletConnector();
  let layoutCrucible = location.pathname.includes("crucible");
  let layoutVesting = location.pathname.includes("vesting");

  useEffect(() => {
    if (isConnected && currentNetworkChainId) {
      for (let item of networksPayload) {
        if (item?.chainId === String(currentNetworkChainId)) {
          dispatch(NetworkActions.setConnectedNetwork(item));
        }
      }
    }
  }, [currentNetworkChainId, networksPayload]);

  const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${theme?.appBackgroundColor} !important;
  }
`;

  return (
    <ThemeProvider theme={theme}>
      <FLayout
        themeBuilder={false}
        className={layoutCrucible ? "layout-crucible scroll-container" : ""}
      >
        {isSwappingScreenBlocked && (
          <div id="overlay">
            <div className="window-lock">
              <p className="window-lock-text">
                <img className="f-mr-1" src={WindowLockWarningIcon} alt="" />
                <span>
                  Swap in progress. Do not navigate away until Swap is
                  completed.
                </span>
              </p>
            </div>
          </div>
        )}
        <DashboardSidebar />
        <FMain>
          {layoutVesting ? (
            <>
              {location.pathname === "/dashboard/vesting/user" && (
                <VestingDashboardHeader title={headerTitle} />
              )}
              <div>{children}</div>
            </>
          ) : (
            <>
              <DashboardHeader title={headerTitle} />
              <FContainer
                type="fluid"
                className={` min-100vh scroll-container ${
                  layoutCrucible ? "f-p-0" : ""
                }`}
              >
                {children}
              </FContainer>
              <DashboardFooter />
            </>
          )}
        </FMain>
      </FLayout>
      <GlobalStyle />
    </ThemeProvider>
  );
};

export default DashboardLayout;
